export const FETCH_PAYMENTS_ACTION = "FETCH_PAYMENTS_ACTION";
export const FETCH_PAYMENTS_FAIL_ACTION = FETCH_PAYMENTS_ACTION + "_ERROR";
export const FETCH_PAYMENTS_SUCCESS_ACTION = FETCH_PAYMENTS_ACTION + "_SUCCESS";

export const FETCH_PAYMENTMODE_ACTION = "FETCH_PAYMENTMODE_ACTION";
export const FETCH_PAYMENTMODE_FAIL_ACTION = FETCH_PAYMENTMODE_ACTION + "_ERROR";
export const FETCH_PAYMENTMODE_SUCCESS_ACTION = FETCH_PAYMENTMODE_ACTION + "_SUCCESS";